<template>
  <div class="education">
    <div class="banner">
      <img src="../../assets/images/banner-edu.png" />
      <div class="text">
        <img src="../../assets/images/banner-edu-text.png" />
      </div>
    </div>
    <div class="block-wrap">
      <div class="flex">
        <Breadcrumbs :routes="breadRoutes" />
        <div class="search-box">
          <input type="text" placeholder="请输入名称搜索" v-model="searchName" />
          <div class="search-btn" @click="searchData">搜索</div>
        </div>
      </div>
      <div class="content-wrap">
        <div class="menu-wrap">
          <div class="menu-item menu-header">
            <div class="menu-icon"></div>
            <span>园林教育</span>
          </div>
          <div
            class="menu-item"
            :class="item.id === category ? 'active' : ''"
            v-for="(item, idx) in categories"
            :key="idx"
            @click="onCategoryChange(item)"
          >
            <div class="menu-icon"></div>
            <span>{{ item.name }}</span>
            <div class="extra-icon"></div>
          </div>
        </div>
        <div class="news-list-wrap">
          <div class="new-list-header">
            <h3>园林教育</h3>
          </div>
          <div class="news-item" v-for="(n, index) in listData" :key="index">
            <div class="news-item-title" @click="toDetail(n)">
              {{ n.title }}
            </div>
            <div class="news-item-extra">{{ n._releaseDate }}</div>
          </div>
          <Pagination
            :currentPage="currentPage"
            :total="total"
            @change="pageChange"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import router from "@/router";
import Breadcrumbs from "@/components/Breadcrumbs";
import Pagination from "@/components/Pagination";
import { getList } from "./service/api";

export default {
  data() {
    return {
      breadRoutes: [
        {
          href: "/",
          name: "首页",
        },
        {
          name: "园林教育",
        },
      ],
      categories: [
        {
          name: "学生园地",
          id: 2001,
        },
        {
          name: "高校教育",
          id: 2002,
        }
      ],
      listData: [],
      category: 2001,
      currentPage: 1,
      pageSize: 10,
      total: 0,
      searchName: ''
    };
  },
  components: {
    Breadcrumbs,
    Pagination
  },
  mounted() {
    this.getList();
  },
  methods: {
    searchData() {
      this.pageChange(1);
    },
    onCategoryChange(item) {
      this.category = item.id;
			this.currentPage = 1;
      this.getList();
    },
    getList() {
      const params = {
        title: this.searchName,
        current: this.currentPage,
        pageSize: this.pageSize,
        categoryDicKey: this.category,
      };
      getList(params).then((res) => {
        this.total = res.totalResult;
        this.listData = (res.list || []).map((item) => {
          item._releaseDate = moment(item.releaseDate*1000 || "").format(
            "YYYY-MM-DD"
          );
          return item;
        });
      });
    },
    pageChange(page) {
      this.currentPage = page;
      this.getList();
    },
    toDetail(item) {
      router.push(`/education/detail?aId=${item.id}`);
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/less/global.less";

.banner {
  width: 100%;
  min-width: @middleWidth;
  margin-bottom: 20px;
  position: relative;

  img {
    display: block;
    width: 100%;
  }

  .text {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);

    > img {
      width: 297px;
    }
  }
}

.content-wrap {
  padding-top: 20px;
  padding-bottom: 40px;
  display: flex;
  position: relative;

  &::before {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 1px;
    opacity: 0.2;
    background: #9d9e9e;
  }

  .menu-wrap {
    width: 180px;
    height: 100%;
    overflow-y: auto;
    position: relative;

    .menu-item {
      width: 180px;
      height: 40px;
      background: #ffffff;
      border: 1px solid #ebecec;
      border-top: none;
      padding: 0 10px 0 13px;
      display: flex;
      align-items: center;
      cursor: pointer;

      &:hover {
        color: #06ae63;
      }

      .menu-icon {
        width: 8px;
        height: 8px;
        background: url(../../assets/images/edu-nav-item.png) no-repeat center
          center;
        background-size: 100% 100%;
        margin-right: 30px;
      }

      .extra-icon {
        width: 12px;
        height: 12px;
        background: url(../../assets/images/icon-right.png) no-repeat center
          center;
        background-size: 100% 100%;
        margin-left: auto;
      }

      &.active {
				color: #06ae63;
        background: #f1f3f3;

        .menu-icon {
          background-image: url(../../assets/images/edu-nav-icon-active.png);
        }
      }

      &.menu-header {
        background: #06ae63;
        color: #ffffff;
        cursor: default;

        .menu-icon {
          width: 13px;
          height: 13px;
          background-image: url(../../assets/images/edu-nav-icon.png);
          margin-right: 14px;
        }
      }
    }
  }

  .news-list-wrap {
    flex: 1;
    padding-left: 20px;
    height: 100%;
    overflow: hidden;
    overflow-y: auto;

    .new-list-header {
      padding: 6px 15px 10px 15px;
      background: url(../../assets/images/edu-list-icon.png) no-repeat 0 center;
      background-size: 6px 24px;
      font-size: 20px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #06ae63;
      line-height: 28px;
      position: relative;

      &::after {
        &:extend(.gray-border);
        top: unset;
        bottom: 0;
      }
    }

    .news-item {
      width: 100%;
      height: 50px;
      position: relative;
      padding: 0 20px 0 15px;
      display: flex;
      align-items: center;

      &:nth-last-child(2) {
        margin-bottom: 40px;
      }

      &::before {
        content: "";
        width: 4px;
        height: 4px;
        background: #d8d8d8;
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
      }

      &::after {
        &:extend(.gray-border);
        top: unset;
        bottom: 0;
      }

      &-title {
        &:extend(.line1);
        width: 80%;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #131415;
        line-height: 22px;
        cursor: pointer;

        &:hover {
          text-decoration: underline;
        }
      }

      &-extra {
        margin-left: auto;
        height: 20px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #787878;
        line-height: 20px;
      }
    }
  }
}

.flex {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.search-box {
  height: 31px;
  display: flex;
  margin-bottom: 23px;

  input {
    width: 243px;
    height: 31px;
    background: #f1f3f3;
    border: none;
    padding: 6px 15px;
    box-sizing: border-box;
  }

  .search-btn {
    width: 95px;
    height: 31px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #06ae63;
    font-size: 14px;
    font-family: SourceHanSansCN-Bold, SourceHanSansCN;
    font-weight: bold;
    color: #ffffff;
    cursor: pointer;
  }
}
</style>